import { isSequential, nodeSize } from "./registry";
export const PRINT_WIDTH = 960;
export const PRINT_MARGIN = 32;
// Keep each state device beside its feeding logic. Four stages fit one A4-width row.
export function compactLayout(project, variant = 0) {
  const p = JSON.parse(JSON.stringify(project));
  const states = p.components.filter(isSequential);
  const sources = p.components.filter(
    (c) => c.type === "CLOCK" || c.type.startsWith("CONST"),
  );
  const combinational = p.components.filter(
    (c) => !isSequential(c) && !sources.includes(c),
  );
  const groups = Array.from({ length: Math.max(1, states.length) }, () => []);
  const downstream = new Map();
  p.connections.forEach((e) => {
    if (e.from.component)
      downstream.set(e.from.component, [
        ...(downstream.get(e.from.component) || []),
        e.to.component,
      ]);
  });
  const target = (c) => {
    const todo = [c.id],
      seen = new Set();
    while (todo.length) {
      const id = todo.shift();
      if (seen.has(id)) continue;
      seen.add(id);
      const index = states.findIndex((s) => s.id === id);
      if (index >= 0) return index;
      todo.push(...(downstream.get(id) || []));
    }
    return groups.reduce(
      (best, items, i) => (items.length < groups[best].length ? i : best),
      0,
    );
  };
  combinational.forEach((c) => groups[target(c)].push(c));
  let top = 55;
  if (states.length) {
    const perRow=Math.min(states.length,combinational.some(c=>nodeSize(c).w>70)||states.some(c=>nodeSize(c).w>85)?3:4);
    for(let row=0;row<Math.ceil(states.length/perRow);row++){
      const count=Math.min(perRow,states.length-row*perRow),width=(PRINT_WIDTH-2*PRINT_MARGIN)/perRow;
      const start=PRINT_MARGIN+(PRINT_WIDTH-2*PRINT_MARGIN-count*width)/2;
      const heights=Array.from({length:count},(_,col)=>{
        const i=row*perRow+col,extent=groups[i].reduce((sum,c)=>sum+nodeSize(c).h+26,0);
        return Math.max(nodeSize(states[i]).h+35,extent+22);
      });
      const rowHeight=Math.max(...heights),center=top+rowHeight/2;
      for(let col=0;col<count;col++){
        const i=row*perRow+col,ff=states[i],items=groups[i],ffSize=nodeSize(ff);
        if(variant%2)items.reverse();
        const left=start+col*width,maxGate=Math.max(58,...items.map(c=>nodeSize(c).w));
        ff.x=left+width-ffSize.w-17;ff.y=center-ffSize.h/2;
        const extent=items.reduce((sum,c)=>sum+nodeSize(c).h+26,0);
        let y=center-Math.max(0,extent-26)/2;
        for(const c of items){c.x=Math.max(left+46,ff.x-maxGate-28);c.y=y;y+=nodeSize(c).h+26;}
      }
      top+=rowHeight+86;
    }
  } else {
    const columnWidths = [0, 0, 0, 0];
    combinational.forEach((c, i) => {
      const col = i % 4;
      c.x = PRINT_MARGIN + col * 224 + 42;
      c.y = 55 + columnWidths[col];
      columnWidths[col] += nodeSize(c).h + 48;
    });
    top = 65 + Math.max(80, ...columnWidths);
  }
  sources.forEach((c, i) => {
    c.x = PRINT_MARGIN + 35 + (i % 6) * 145;
    c.y = top + Math.floor(i / 6) * 68;
  });
  p.connections = p.connections.map((e) => {
    const n = { ...e };
    delete n.waypoints;
    delete n.anchors;
    delete n.routeOffset;
    delete n.terminal;
    return n;
  });
  p.metadata = { ...p.metadata, paper: "A4", layout: "compact-stages" };
  return p;
}
